/**
 * Takes an (async) iterable and returns one with each item mapped by the passed
 * function
 */
export default async function* map(source, func) {
    for await (const val of source) {
        yield func(val);
    }
}
//# sourceMappingURL=index.js.map